module.exports = __webpack_public_path__ + "img/debian.9fe70a34.svg";